// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2Oh1L","info":"PatientInfo_info__28gdA"};